
// Data Structure:

// {
// 		title: "Opening",
// 		start: "",
// 		end: "",
// 		break: true, 		// <- true | false
// 		vimeo: "",  // <- "vimeoID"
// 		youtube: "", // <- "youtubeID"
// 		slides: "filename.pdf", // <- "Filename Slides"
// 		slides: [ // <- Multiple slides
// 			{
// 				name: "Title",
// 				file: "Filename.pdf"
// 			},
// 			...
//      ],
// 		chair: {
// 			name: "Andre Bourdoux",
// 			affiliation: "IMEC, Belgium"
// 		},
// 		papers: [
// 			{
// 				"title": "The Paper Title",
// 				"authors": "A. Bourdoux, T. Ußmüller",
// 				"ptype": "virtual"
// 			},
// 			{
// 				"title": "Yet Another Paper Title",
// 				"authors": "J. Doe, J. Smith",
// 				"ptype": "physical"
// 			},
// 		],
// 		speaker: "Fabian Diehm",
// 		affiliation: "TU Dresden, Dresden, Germany",
// 		ptype: "virtual", 	// <- "physical" | "virtual"
// 		misc: "", 			// <- any html possible
// },


export const programdata = [
	{
		title: "Day 1",
		date: "2023-03-05",
		slidefolder: "/slides/2023/AE091EGS",
		items: [
			{
				title: "Registration",
				start: "8:30",
				end: "9:00",
				break: true,
			},
			{
				title: "Tutorial 1: Transceiver Architectures for Joint Communication and Sensing",
				start: "9:00",
				end: "10:30",
				chair: {
					name: "Dr. Giuseppe Gramegna",
					affiliation: "IMEC, Belgium"
				},
				slides: "tutorial_gramegna.pdf",
				vimeo: "806253544?h=8854926a72",
				misc: `
					<div style="margin-top: 0.5em; font-size: 0.9em; font-style: italic;">
						Abstract: The tutorial will cover Transceivers (TRXs) architectures for communications and sensing with a strong focus on Hardware (HW) implementation. Beamforming and MIMO will be discussed. The challenge associated to the addition of sensing capabilities into an existing communication system at a minimal cost will be presented as well. The three sections of the tutorial will be: (1) Wireless communication and FMCW basics, (2) MIMO and Beamforming and (3)TRX implementations for wireless comm and how to add sensing into a wireless communication TRX to be addressed for addition of a sensing functionality will be reported, together with possible examples of implementation from the TRX HW point of view.
					</div>`
			},
			{
				title: "Coffee Break",
				start: "10:30",
				end: "10:45",
				break: true,
			},
			{
				title: "Tutorial 2: Multi-Function Intelligent Surfaces for Communication and Sensing",
				start: "10:45",
				end: "12:15",
				chair: {
					name: "Prof. Marco Di Renzo",
					affiliation: "Paris-Saclay University, France"
				},
				vimeo: "806259630?h=b2715d4d73",
				misc: `<div style="margin-top: 0.5em; font-size: 0.9em; font-style: italic;">
					Abstract: An intelligent surface is planar metamaterial that is engineered to have properties that enable the dynamic control of the electromagnetic waves. In wireless communications, intelligent surfaces constitute an emerging technology for realizing programmable and reconfigurable wireless propagation environments through nearly passive and tunable signal transformations. This tutorial is aimed to report the latest research advances on modeling, analyzing, and optimizing multi-function intelligent surfaces for communication and sensing applications, with focus on electromagnetically consistent models, performance evaluation, and optimization algorithms.
				</div>`
			},
			{
				title: "Lunch Break",
				start: "12:15",
				end: "13:15",
				break: true,
			},
			{
				title: "Tutorial 3, Session 1: Introduction, Fundamentals, ISAC Beamforming and Waveform Optimization",
				start: "13:15",
				end: "14:45",
				chair: {
					name: "Prof. Visa Koivunen",
					affiliation: "Aalto University, Finland"
				},
				slides: "tutorial_koivunen.pdf",
				vimeo: "806275487?h=8e556dbe8f",
				misc: `<div style="margin-top: 0.5em; font-size: 0.9em; font-style: italic;">
					Abstract: Integrated Sensing and Communications Systems (ISAC) sense radio frequency spectrum and transfer wireless data jointly. ISAC systems cooperate or are co-designed for mutual benefits. Co-designed systems may share spectrum, HW and antenna resources and awareness about the state of the spectrum. The operational parameters of ISAC systems may be adjusted either by using structured optimization or machine learning. We will focus on waveform design and optimization for joint radar and communications with quantitative performance guarantees. A variety of radar sensing tasks and their performance criteria will be discussed. As examples, we will present multicarrier waveform optimization, reinforcement learning, interference management and beamformers for ISAC. Furthermore, we will present OFDM radar signal processing algorithms in ISAC that can take advantage of nonidealities that are commonly considered an impairment in wireless communications but are vital in radar tasks.
				</div>`
			},
			{
				title: "Coffee Break",
				start: "14:45",
				end: "15:15",
				break: true,
			},
			{
				title: "Tutorial 3, Session 2: Cellular Positioning & Simultaneous Localization and Mapping (SLAM)",
				start: "15:15",
				end: "16:30",
				chair: {
					name: "Prof. Mikko Valkama",
					affiliation: "Tampere University, Finland"
				},
				slides: "tutorial_valkama.pdf",
				vimeo: "806290959?h=942542f52b",
				misc: `<div style="margin-top: 0.5em; font-size: 0.9em; font-style: italic;">
					Abstract: In this session of the tutorial, we discuss the fundamentals and recent advances in cellular radio positioning and radio SLAM. While classical positioning seeks to provide information of the locations of the user equipment, SLAM allows to also estimate and track the locations of the landmarks and scattering points of the environment for enhanced situation awareness. We discuss and review the 5G NR  reference signals available in uplink and downlink for positioning and SLAM, while also present recent advances in sophisticated random finite set (RFS) based filtering solutions allowing for probabilistic modelling of landmarks and the corresponding birth and death processes. Another recent paradigm of turning the user equipment into monostatic and/or collaborative bistatic mobile radars while transmitting the uplink data signal is also discussed.
				</div>`
			},
			{
				title: "Tutorial 3, Session 3: ISAC and Reconfigurable Intelligent Surface (RIS) as a System Enhancement",
				start: "16:40",
				end: "18:00",
				chair: {
					name: "Prof. Markku Juntti",
					affiliation: "University of Oulu, Finland"
				},
				slides: "tutorial_juntti.pdf",
				vimeo: "806307682?h=cb02969f28",
				misc: `<div style="margin-top: 0.5em; font-size: 0.9em; font-style: italic;">
					Abstract: In this session of the tutorial, we discuss the channel estimation approaches with RIS as a system component. Channel estimation is one possible enabler for mobile positioning or radar type target detector and their connections are discussed. The structured channel models with sparsity properties in the mmWave band enable efficient estimation algorithms, which readily provide direction information useful also for positioning and sensing. In addition, we elaborate on the system level performance benefits of RISs and their assessment using theoretical analytical results and also realistic ray tracing simulation tools.
				</div>`
			},
			{
				title: "Welcome Reception BBQ @ Conference Center Seefeld",
				start: "18:00",
				break: true,
			}
		]
	},
	{
		title: "Day 2",
		date: "2023-03-06",
		slidefolder: "/slides/2023/AE091EGS",
		items: [
			{
				title: "Morning Coffee",
				start: "8:30",
				end: "9:00",
				break: true,
			},
			{
				title: "Conference Opening - Welcome Address",
				speaker: "Prof. Gerhard Fettweis (TU Dresden), Prof. Thomas Ußmüller (Universität Innsbruck)",
				start: "9:00",
				end: "9:15",
				slides: "opening_slides.pdf",
				vimeo: "806509994?h=767b5e9cf6",
			},
			{
				title: "Keynote: Crowd Monitoring with 802.11ax-based Passive Radars",
				speaker: "Prof. François Horlin",
				affiliation: "Université libre de Bruxelles, Belgium",
				start: "9:15",
				end: "9:55",
				slides: "keynote_horlin.pdf",
				vimeo: "806271793?h=0d83d3d2aa",
			},
			{
				title: "Coffee Break",
				start: "9:55",
				end: "10:10",
				break: true,
			},
			{
				title: "Keynote: 6 Paradigm Shifts for 6G - Wireless Connectivity Beyond Communications",
				speaker: "Prof. Angeliki Alexiou",
				affiliation: "University of Piraeus, Greece",
				start: "10:10",
				end: "10:50",
				slides: "keynote_alexiou.pdf",
				vimeo: "806286642?h=6a86600a29",
			},
			{
				title: "Coffee Break",
				start: "10:50",
				end: "11:00",
				break: true,
			},
			{
				title: "Paper Session I: Beamforming and Antenna Design",
				start: "11:00",
				end: "12:20",
				chair: {
 				name: "Padmanava Sen",
 				affiliation: "Barkhausen Institut, Germany"
				},
				papers: [
					{
						"title": "Passive Wi-Fi-Based Radars with 802.11ax MU-MIMO Signals: AoD Estimation with a Single Antenna",
						"authors": "Hasan Can Yildirim, Laurent Storrer (Univesité Libre de Bruxelles (ULB), Belgium); Martin Willame (Université Catholique de Louvain (UCLouvain) & Université Libre de Bruxelles (ULB), Belgium); Jerome Louveaux (Université catholique de Louvain, Belgium); Philippe De Doncker; François Horlin (Université Libre de Bruxelles, Belgium)",
					},
					{
						"title": "Defected Ground Structure-Based Compact Wideband Monopole Antenna Design with Equivalent Circuit Modeling for Communication and Sensing Applications",
						"authors": "Mohammad Rabiul Hossen, Mehrab Ramzan, Padmanava Sen (Barkhausen Institut, Germany)",
					},
					{
						"title": "Antenna-Duplexed Passive Beamforming Front-End for Joint Communication and Sensing",
						"authors": "Muhammad Umar, Padmanava Sen (Barkhausen Institut, Germany)"
					},
					{
						"title": "A Codebook Approach to Spillover Cancellation in Multi-Antenna Radar and Communication Systems",
						"authors": "Adham Sakhnini, Andre Bourdoux (IMEC, Belgium); Sofie Pollin (KU Leuven, Belgium)",
					},
				],
				vimeo: "806304014?h=cd05545c4c",
			},
			{
				title: "Business Lunch",
				start: "12:20",
				end: "13:20",
				break: true,
			},
			{
				title: "Paper Session II: Applications and Simulation",
				start: "13:20",
				end: "14:40",
				chair: {
 				name: "Prof. Jérôme Louveaux",
 				affiliation: "UCLouvain, Belgium"
				},
				papers: [
					{
						"title": "Analysis of V2X Sidelink Positioning in Sub-6 GHz",
						"authors": "Yu Ge (Chalmers University of Technology, Sweden); Maximilian Stark (Robert Bosch GmbH, Germany); Musa Furkan Keskin (Chalmers University of Technology, Sweden); Frank Hofmann, Thomas Hansen (Robert Bosch GmbH, Germany); Henk Wymeersch (Chalmers University of Technology, Sweden)",
					},
					{
						"title": "Sensing-Assisted Receivers for Resilient-By-Design 6G MU-MIMO Uplink",
						"authors": "Vlad Costin Andrei, Xinyang Li, Ullrich J Mönich, Holger Boche (Technical University Munich, Germany)",
					},
					{
						"title": "A CSP's View on Opportunities and Challenges of Integrated Communications and Sensing",
						"authors": "Arndt Kadelka, Gerd Zimmermann, Jan Plachy, Oliver Holschke (Deutsche Telekom AG, Germany)",
					},
					{
						"title": "Framework for Simulation Models and Algorithms in ISAC Networks",
						"authors": "Carsten Smeenk (Fraunhofer Institute for Integrated Circuits & TU Ilmenau, Germany); Reiner S. Thomä (Ilmenau University of Technology, Germany); Christian Schneider (Fraunhofer Institute for Integrated Circuits)",
					},
				],
				vimeo: "806416121?h=ea9de27e00",
			},
			{
				title: "Demo Teasers",
				start: "14:40",
				end: "15:00",
			},
			{
				title: "Demos + Coffee Break",
				start: "15:00",
				end: "16:10",
				break: true,
			},
			{
				title: "Invited Talk: The Path from 6G Research Towards Prototyping of Joint Communication & Sensing Testbeds",
				speaker: "Dr. Amr Haj-Omar",
				affiliation: "NI",
				start: "16:10",
				end: "16:30",
				slides: "invitedtalk_ni.pdf",
				vimeo: "806267986?h=c52a142fc9",
			},
			{
				title: "Panel: Is JC&S ready for 6G Deployment in 2030?",
				chair: {
					name: "Prof. Gerhard Fettweis",
					affiliation: "TU Dresden, Germany"
				},
				speaker: "Dr. Frank Hofmann (Robert Bosch GmbH), Dr. Arndt Kadelka (Deutsche Telekom AG), Prof. Norman Franchi (FAU, Germany), Dr. Ashish Pandharipande (NXP)",
				start: "16:40",
				end: "17:40",
				slides: [ 
					{
						name: "Intro Hofmann", 
						file: "panel_hofmann.pdf"
					}, 
					{
						name: "Intro Kadelka", 
						file: "panel_kadelka.pdf"
					},
					{
						name: "Intro Franchi", 
						file: "panel_franchi.pdf"
					},
					{
						name: "Intro Pandharipande", 
						file: "panel_pandharipande.pdf"
					},
				],
				vimeo: "806650496?h=eaa9efbf7e",
			},
			{
				title: "Social Dinner @Gschwandtkopf",
				start: "19:00",
				break: true,
			}


		]
	},
	{
		title: "Day 3",
		date: "2023-03-07",
		slidefolder: "/slides/2023/AE091EGS",
		items: [
			{
				title: "Morning Coffee",
				start: "8:30",
				end: "9:00",
				break: true,
			},
			{
				title: "Invited Talk: 6G Integrated Sensing and Communications",
				speaker: "Dr. Wen Tong",
				affiliation: "Huawei Wireless",
				start: "09:00",
				end: "09:20",
				slides: "invitedtalk_tong",
				vimeo: "806450181?h=9cf7d3c519",
			},
			{
				title: "(Presented Afterwards) Keynote: AI-Native Air Interface for Communications and Sensing ",
				start: "9:20",
				end: "10:00",
				speaker: "Dr. Dani Korpi",
				affiliation: "Nokia",
				vimeo: "814490703?h=4e1cee2c36",
			},
			{
				title: "Paper Session III: Interference and Spectral Efficiency",
				start: "10:00",
				end: "11:00",
				chair: {
 					name: "Ahmad Nimr",
 					affiliation: "TU Dresden, Germany"
				},
				papers: [
					{
						"title": "Interference Mitigation in Joint Communications and Sensing-Part I: Correlation and Collision",
						"authors": "Husheng Li (Purdue University, USA)",
					},
					{
						"title": "Interference Mitigation in Joint Communications and Sensing-Part II: Coding and Spreading",
						"authors": "Husheng Li (Purdue University, USA)",
					},
					{
						"title": "Spectral Efficiency Analysis for a Spike-Based Pulse Repetition Frequency Modulation Scheme",
						"authors": "Florian Roth, Meik Dörpinghaus, Gerhard P. Fettweis (Technische Universität Dresden, Germany)",
					},
				],
				vimeo: "806433076?h=3efe37ce27",
			},
			{
				title: "Coffee Break",
				start: "11:00",
				end: "11:15",
				break: true,
			},
			{
				title: "Paper Session IV: Environment Sensing & Monitoring",
				start: "11:15",
				end: "12:35",
				chair: {
 				name: "André Bourdoux",
 				affiliation: "IMEC, Belgium"
				},
				papers: [
					{
						"title": "6G Radio-Based Parking Lot Detection",
						"authors": "Maximilian Bauhofer, Yu Zhang (University of Stuttgart, Germany); Maximilian Arnold (Qualcomm AI, Germany); Stephan ten Brink (University of Stuttgart, Germany)",
					},
					{
						"title": "26 GHz OFDM and 77 GHz FMCW Radar Dataset for Domain Shift Invariant Blockage Prediction",
						"authors": "Bram van Berlo (Eindhoven University of Technology, The Netherlands); Yang Miao (University of Twente, The Netherlands); Rizqi Hersyandika (KU Leuven, Belgium); Ben Willetts and Kai Mao (University of Twente, The Netherlands); Amin Zare and Sofie Pollin (KU Leuven, Belgium); Nirvana Meratnia (Eindhoven University of Technology, The Netherlands)",
					},
					{
						"title": "Crowd Counting Model Training with the Method of Moments in Electromagnetics",
						"authors": "Laurent Storrer, Hasan Can Yildirim (Université Libre de Bruxelles (ULB), Belgium); Martin Willame (Université Catholique de Louvain (UCLouvain) & Université Libre de Bruxelles (ULB), Belgium); Jerome Louveaux (Université catholique de Louvain, Belgium); Philippe De Doncker (ULB, Belgium); Sofie Pollin (KU Leuven, Belgium); François Horlin (Université Libre de Bruxelles, Belgium)",
					},
					{
						"title": "Improving Radio Environment Maps with Joint Communications and Sensing: An Outlook",
						"authors": "Anton Krause, Philipp Schulz, Gerhard P. Fettweis (Technische Universität Dresden, Germany)",
					},
				],
				vimeo: "806456272?h=07d16b08db",
			},
			{
				title: "Business Lunch",
				start: "12:35",
				end: "13:25",
			},
			{
				title: "Paper Session V: Virtual Presentations",
				start: "13:25",
				end: "15:05",
				chair: {
 				name: "Fan Liu",
 				affiliation: "SUSTech, China"
				},
				papers: [
					{
						"title": "A Novel Waveform Design for OFDM-Based Joint Sensing and Communication System",
						"authors": "Yi Geng (Cict Mobile, China)",
					},
					{
						"title": "OTFS Communications-Assisted Environment Sensing",
						"authors": "Buyi Li, Weijie Yuan (Southern University of Science and Technology, China)",
					},
					{
						"title": "Dirichlet Process Clustering-Based Radio SLAM with Arbitrarily-Shaped Reflectors",
						"authors": "Jaebok Lee (Hanyang University, Korea (South)); Hyowon Kim, Henk Wymeersch (Chalmers University of Technology, Sweden); Sunwoo Kim (Hanyang University, Korea (South))",
					},
					{
						"title": "Software-Defined MIMO OFDM Joint Radar-Communication Platform with Fully Digital mmWave Architecture",
						"authors": "Ceyhun D Ozkaptan, Haocheng Zhu, Eylem Ekici (The Ohio State University, USA); Onur Altintas (Toyota Motor North America R&D, InfoTech Labs, USA)",
					},
					{
						"title": "Secure Integrated Sensing and Communication for Binary Input Additive White Gaussian Noise",
						"authors": "Onur Günlü (Linköping University, Sweden); Matthieu Bloch (Georgia Institute of Technology, USA); Rafael F. Schaefer (Technische Universität Dresden, Germany); Aylin Yener (The Ohio State University, USA)",
					},
				],
				vimeo: "806639078?h=56e85ba9b8",
			},
			{
				title: "Coffee Break",
				start: "15:05",
				end: "15:20",
				break: true,
			},
			{
				title: "Closing Keynote: Wi-Fi Joint Communication & Sensing: Recent Advances & Technology Directions",
				start: "15:20",
				end: "16:00",
				speaker: "Dr. Carlos Cordeiro",
				affiliation: "Intel, USA",
				slides: "keynote_cordeiro.pdf",
				vimeo: "806536505?h=b3099f8802",
			},
			{
				title: "Conference Closing Speeches",
				speaker: "André Bourdoux (IMEC), Prof. Gerhard Fettweis (TU Dresden), Prof. Thomas Ußmüller (Universität Innsbruck)",
				start: "16:10",
				end: "17:00",
				slides: [ 
				{
					name: "Conference Summary", 
					file: "summary_bourdoux.pdf"
				}, 
				{
					name: "Closing Slides", 
					file: "closing_slides.pdf"
				},
				],
				vimeo: "806646833?h=4fb0697306",
			}

		]
	}
]
